import { disableScroll, enableScroll } from './helpers';

export default class ShopFilters {
    initButtonTogglers = async () => {
        this.togglerButtons = document.querySelectorAll('.filter-toggler');
        this.widgets = document.querySelector('.widgets');
        this.filtersAreOpen = false;

        this.initEvents();
    };

    init = async () => {
        this.filters = [...document.querySelectorAll('aside.shop-filters li input')];
        this.endPrefix = document.querySelector('.wcapf-range-end');
        this.PREFIX_TEXT = 'Do:';
        this.changePrefixText();
    };

    changePrefixText = async () => {
        const prefix = this.endPrefix.querySelector('.wcapf-range-prefix');
        prefix.textContent = this.PREFIX_TEXT;
    };

    toggleFilters = () => {
        this.filtersAreOpen ? enableScroll() : disableScroll();

        this.widgets.classList.toggle('-translate-x-full');

        this.filtersAreOpen = !this.filtersAreOpen;
    };

    initEvents = async () => {
        this.filters.forEach(async (item) => {
            item.checked ? item.parentNode.classList.add('chosen') : item.parentNode.classList.remove('chosen');
        });

        this.togglerButtons.forEach(async (button) => {
            button.addEventListener('click', this.toggleFilters);
        });
    };
}
